<div class="min-h-screen bg-gray-50 flex items-center justify-center p-4">
  <div class="max-w-md w-full text-center space-y-8 animate-fadeIn">

    <!-- Illustration / Icon Container -->
    <div class="relative group cursor-default">
      <div
        class="absolute -inset-1 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl blur opacity-20 group-hover:opacity-40 transition duration-1000 group-hover:duration-200">
      </div>
      <div class="relative bg-white rounded-2xl shadow-xl border border-gray-100 p-8 overflow-hidden">

        <!-- Large 404 Text -->
        <h1
          class="text-[120px] font-black text-transparent bg-clip-text bg-gradient-to-br from-blue-600 to-indigo-600 leading-none select-none tracking-tighter">
          404
        </h1>

        <!-- Decorative Elements -->
        <div class="absolute top-0 right-0 -mr-8 -mt-8 w-24 h-24 bg-blue-50 rounded-full blur-xl opacity-50"></div>
        <div class="absolute bottom-0 left-0 -ml-8 -mb-8 w-24 h-24 bg-indigo-50 rounded-full blur-xl opacity-50"></div>

        <div class="mt-4">
          <h2 class="text-2xl font-bold text-gray-900 mb-2">Page Not Found</h2>
          <p class="text-gray-500 font-medium">
            Oops! The page you're looking for seems to have vanished into the digital void.
          </p>
        </div>
      </div>
    </div>

    <!-- Actions -->
    <div class="space-y-4">
      <button (click)="goToHome()"
        class="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-gray-900 hover:bg-black text-white rounded-xl font-semibold transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5 focus:ring-4 focus:ring-gray-200">
        <span class="material-symbols-outlined text-[20px]">home</span>
        Return Home
      </button>

      <!-- Optional secondary action (e.g., support or back) can go here -->
    </div>

    <p class="text-xs text-gray-400 font-medium">
      Error Code: 404 • trkbl.com
    </p>

  </div>
</div>